import { BuildingOfficeIcon, ClipboardIcon, EnvelopeIcon, FolderIcon, HomeIcon } from '@heroicons/react/24/outline'
import type { FeatureAccess } from 'Model/User/IUser.js'
import { FeatureAccesses } from 'Model/User/IUser.js'
import { CreateOrderMenuItem } from './CreateOrderItem.js'
import { SpinIdCardIcon } from '../SpinIdCard/SpinIdCardIcon.js'
import { projectsRouteFeatureAccess, spinRouteFeatureAccess } from 'Model/User/featureGating.js'
import type { Subject } from 'rxjs'
import type { ReactNode } from 'react'
import React from 'react'

export interface MenuItemProps {
  icon: React.ReactNode
  label: string
  path: string
  requiredFeatureAccess?: FeatureAccess
  id?: string
  testId?: string
  /** Number shown next to the label; nothing shows for 0 or undefined. */
  badge?: (counts: MenuBadgeCounts) => number | undefined
}

export interface MenuBadgeCounts {
  pendingInvites?: number
}

export interface CustomMenuItemProps {
  onNavigate$: Subject<string>
}

export type CustomMenuItem = {
  item: (props: CustomMenuItemProps) => ReactNode
  requiredFeatureAccess?: FeatureAccess
}

export function isCustomMenuItem(item: MenuItemProps | CustomMenuItem): item is CustomMenuItem {
  return Object.hasOwn(item, 'item')
}

export function isMenuItemProps(item: MenuItemProps | CustomMenuItem): item is MenuItemProps {
  return !Object.hasOwn(item, 'item')
}

export const menuItems: (MenuItemProps | CustomMenuItem)[] = [
  {
    icon: <HomeIcon className="w-6 h-6 shrink-0" />,
    label: 'Dashboard',
    path: '/home',
    requiredFeatureAccess: FeatureAccesses.TIER1,
    id: 'tour-sidebar-dashboard'
  },
  {
    item: CreateOrderMenuItem,
    requiredFeatureAccess: FeatureAccesses.TIER1
  },
  {
    icon: <ClipboardIcon className="w-6 h-6 shrink-0" />,
    label: 'My Orders',
    path: '/order_management',
    requiredFeatureAccess: FeatureAccesses.TIER1,
    id: 'tour-sidebar-orders'
  },
  {
    icon: <EnvelopeIcon className="w-6 h-6 shrink-0" />,
    label: 'Invitations',
    path: '/invite',
    testId: 'invite-page',
    badge: (counts) => counts.pendingInvites
  },
  {
    icon: <FolderIcon className="w-6 h-6 shrink-0" />,
    label: 'My Projects',
    path: '/projects',
    requiredFeatureAccess: projectsRouteFeatureAccess
  },
  {
    icon: <BuildingOfficeIcon className="w-6 h-6 shrink-0" />,
    label: 'Marketplace',
    path: '/marketplace',
    requiredFeatureAccess: FeatureAccesses.TIER1
  },
  {
    icon: <SpinIdCardIcon className="w-6 h-6 shrink-0" />,
    label: 'SPINs',
    path: '/spins',
    requiredFeatureAccess: spinRouteFeatureAccess,
    id: 'sidebar-spins'
  }
]
